import { formatCurrency, formatDecimalUnit } from '@/common/utils/formatters';
import { GovernmentAllocationAllowedCategoriesAndProducts } from '../types/governmentAllocation.type';
import { BoxesIcon, FileBoxIcon } from 'lucide-react';

export class GovernmentAllocationsAllowedCategoriesAndProductsTransformer {

  static optionsTransformer(key: 'categories' | 'products', isConsumptionControlledByQuantity?: boolean) {
    return (categoriesAndProducts: GovernmentAllocationAllowedCategoriesAndProducts) => {
      if (!categoriesAndProducts || Array.isArray(categoriesAndProducts)) return []

      return Object.entries(categoriesAndProducts?.[key])?.map(([id, data]) => ({
        ...data,
        value: id,
        label: (
          <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-1'>
              {key === 'categories' ? <BoxesIcon strokeWidth={1.5} size={16} /> : <FileBoxIcon strokeWidth={1.5} size={16} />}

              <p>
                {data.display_name}
              </p>
            </div>

            <div className='flex flex-col gap-px'>
              <p className='italic text-xs text-white-400'>
                  {isConsumptionControlledByQuantity
                    ? `Quantidade disponível: ${formatDecimalUnit(Number(data.available_quantity) || 0, data.unit_for_quantity)}`
                    : `Total disponível: ${formatCurrency(Number(data.available_total) || 0)}`
                  }
              </p>
            </div>
          </div>
        ),
      }))
    }
  }

}
